/**
 * Factory file for document related data.
 *
 * @exports document
 * @category Factories
 */
export default {
  getDocument: (initialData = {}) => ({
    id: 5091,
    project_id: 687,
    document_type: 'Proposal',
    state: 'not_started',
    created_at: '2019-10-29T19:54:23.044294',
    updated_at: '2019-10-29T19:54:23.044294',
    carrier: {
      id: 53,
      name: 'OneAmerica',
      logo_url: 'https://watchtower-public.s3.amazonaws.com/carriers/logos/oneamerica/original/one-america-large_3x.png?1566618675',
      small_logo_url: 'https://watchtower-public.s3.amazonaws.com/carriers/small_logos/oneamerica/small_logo/one-america-icon_3x.png?1566618675',
      has_files: false,
    },
    ...initialData,
  }),
};
